// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminReviewsManagement-space1-OSy7I {
	margin-bottom: 6px !important;
}

.AdminReviewsManagement-space2-lRuD8 {
	margin-bottom: 12px !important;
}

.AdminReviewsManagement-space3-z0tH4 {
	margin-bottom: 18px !important;
}

.AdminReviewsManagement-space4-cStCW {
	margin-bottom: 24px !important;
}

.AdminReviewsManagement-space5-FP9EM {
	margin-bottom: 30px !important;
}

.AdminReviewsManagement-space6-usXWq {
	margin-bottom: 36px !important;
}

.AdminReviewsManagement-space7-P7b8F {
	margin-bottom: 42px !important;
}

.AdminReviewsManagement-space8-rEbcK {
	margin-bottom: 48px !important;
}

.AdminReviewsManagement-spaceTop1-o_iMV {
	margin-top: 6px !important;
}

.AdminReviewsManagement-spaceTop2-JZwZr {
	margin-top: 12px !important;
}

.AdminReviewsManagement-spaceTop3-y2lwS {
	margin-top: 18px !important;
}

.AdminReviewsManagement-spaceTop4-qcsg1 {
	margin-top: 24px !important;
}

.AdminReviewsManagement-spaceTop5-PXot4 {
	margin-top: 30px !important;
}

.AdminReviewsManagement-spaceTop6-Vi1xj {
	margin-top: 36px !important;
}

.AdminReviewsManagement-spaceTop7-LSsWJ {
	margin-top: 42px !important;
}

.AdminReviewsManagement-spaceTop8-HuUDM {
	margin-top: 48px !important;
}

.AdminReviewsManagement-noMargin-X_09I {
	margin: 0px !important;
}

.AdminReviewsManagement-padding1-NorlO {
	padding-bottom: 6px !important;
}

.AdminReviewsManagement-padding2-ORdMJ {
	padding-bottom: 12px !important;
}

.AdminReviewsManagement-padding3-UNlNj {
	padding-bottom: 18px !important;
}

.AdminReviewsManagement-padding4-Xj17H {
	padding-bottom: 24px !important;
}

.AdminReviewsManagement-padding5-di7vk {
	padding-bottom: 30px !important;
}

.AdminReviewsManagement-padding6-MyBkh {
	padding-bottom: 36px !important;
}

.AdminReviewsManagement-padding7-DEA_R {
	padding-bottom: 42px !important;
}

.AdminReviewsManagement-paddingTop1-ZFjOg {
	padding-top: 6px !important;
}

.AdminReviewsManagement-paddingTop2-TLmNR {
	padding-top: 12px !important;
}

.AdminReviewsManagement-paddingTop3-ifIW7 {
	padding-top: 18px !important;
}

.AdminReviewsManagement-paddingTop4-Rt0gH {
	padding-top: 24px !important;
}

.AdminReviewsManagement-paddingTop5-BFzPe {
	padding-top: 30px !important;
}

.AdminReviewsManagement-paddingTop6-orvG0 {
	padding-top: 36px !important;
}

.AdminReviewsManagement-paddingTop7-m9XJT {
	padding-top: 42px !important;
}

.AdminReviewsManagement-noPadding-xHJHQ {
	padding: 0px !important;
}

.AdminReviewsManagement-spaceMarginBottom0-yHcOp {
	margin-bottom: 0;
}

.AdminReviewsManagement-textBold-UTEZT {
	font-weight: 500 !important;
}

.AdminReviewsManagement-textBolder-qRkx0 {
	font-weight: 700 !important;
}

.AdminReviewsManagement-textNormal-P9C1d {
	font-weight: normal !important;
}

/*New Design Text Colors */

.AdminReviewsManagement-textDarkBlue-BB6d2 {
	color: rgb(20, 39, 94) !important;
}

.AdminReviewsManagement-textLightBlue-gVNRe {
	color: rgb(57, 87, 106) !important;
}

.AdminReviewsManagement-textLightSandleGreen-QKWAM {
	color: rgb(76, 86, 41) !important;
}

.AdminReviewsManagement-textLightBrown-k8jjV {
	color: rgb(115, 79, 33) !important;
}

.AdminReviewsManagement-textMediumMaroon-rUMW0 {
	color: rgb(87, 37, 51) !important;
}

.AdminReviewsManagement-textBrown-zXUBF {
	color: rgb(160, 47, 24) !important;
}

.AdminReviewsManagement-textMaroon-MJJjC {
	color: rgb(155, 49, 67) !important;
}

.AdminReviewsManagement-textDarkBrown-_MxLe {
	color: rgb(83, 18, 16) !important;
}

.AdminReviewsManagement-textMediumBrown-kY21R {
	color: rgb(142, 28, 10) !important;
}

.AdminReviewsManagement-textSkyBlue-e1OVR {
	color: rgb(37, 117, 141) !important;
}

.AdminReviewsManagement-textGray-_v0Cc {
	color: rgb(77, 65, 51) !important;
}

.AdminReviewsManagement-errorMessage-sCLqH {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.AdminReviewsManagement-userText-yQTOM {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.AdminReviewsManagement-panelHeader-ddJN0 {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.AdminReviewsManagement-exportSection-MLS1S {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.AdminReviewsManagement-exportSectionGridSub-oOKWf {
	grid-template-columns: 50% 49% !important;
}

.AdminReviewsManagement-exportText-o_TC7 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.AdminReviewsManagement-exportLinkImg-laZNn {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.AdminReviewsManagement-exportImg-suzog {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AdminReviewsManagement-linkBtn-KlQCa {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.AdminReviewsManagement-table-DQqPa {
	display: table;
}

.AdminReviewsManagement-tableRow-lyVhT {
	display: table-row;
}

.AdminReviewsManagement-tableCell-qEQn2 {
	display: table-cell;
	float: none;
}

.AdminReviewsManagement-formGroup-HTFkm {
	margin-bottom: 6px;
}

.AdminReviewsManagement-marginTop0-JJp5f {
	margin-top: 0;
}

.AdminReviewsManagement-marginBottom20-BGybb {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.AdminReviewsManagement-bannerImageBg-MLNoM {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.AdminReviewsManagement-bannerDelete-zoJrr {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.AdminReviewsManagement-exportLink-LNj__ {
	padding-top: 10px;
	padding-right: 10px;
}

.AdminReviewsManagement-seachContent-MIcED {
	padding-left: 0px;
	margin-bottom: 5px;
}

.AdminReviewsManagement-marginBottom9-odZSA {
	margin-bottom: 9px;
}

.AdminReviewsManagement-spaceTop52-rS8E5 {
	margin-top: 52px;
}

.AdminReviewsManagement-profileViewInner-cIh7V {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.AdminReviewsManagement-profileViewMain-OSMaT {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.AdminReviewsManagement-profileViewlabel-JZldS {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.AdminReviewsManagement-profileViewMainContent-oIVgm {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.AdminReviewsManagement-reviewsFormStar-_LBKD {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.AdminReviewsManagement-reviewsFormStar-_LBKD svg {
	cursor: pointer;
}

.AdminReviewsManagement-addLanguageText-KUgqg {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.AdminReviewsManagement-exportSection-MLS1S {
		grid-template-columns: 100%;
	}

	.AdminReviewsManagement-spaceTop52-rS8E5 {
		margin-top: 18px;
	}

	.AdminReviewsManagement-exportText-o_TC7 {
		float: none;
		margin-top: 12px;
	}

	.AdminReviewsManagement-exportSectionGridSub-oOKWf {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.AdminReviewsManagement-profileViewlabel-JZldS {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AdminReviewsManagement-profileViewMainContent-oIVgm {
		width: 100%;
		text-align: center;
	}

	.AdminReviewsManagement-panelHeader-ddJN0 {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.AdminReviewsManagement-textRight-Z7ViW {
    text-align: right;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/WhyHostPageSettings/AdminReviewsManagement/AdminReviewsManagement.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,iBAAiB;AACrB","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../../admin-common.css';\n\n.textRight {\n    text-align: right;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `AdminReviewsManagement-space1-OSy7I`,
	"space2": `AdminReviewsManagement-space2-lRuD8`,
	"space3": `AdminReviewsManagement-space3-z0tH4`,
	"space4": `AdminReviewsManagement-space4-cStCW`,
	"space5": `AdminReviewsManagement-space5-FP9EM`,
	"space6": `AdminReviewsManagement-space6-usXWq`,
	"space7": `AdminReviewsManagement-space7-P7b8F`,
	"space8": `AdminReviewsManagement-space8-rEbcK`,
	"spaceTop1": `AdminReviewsManagement-spaceTop1-o_iMV`,
	"spaceTop2": `AdminReviewsManagement-spaceTop2-JZwZr`,
	"spaceTop3": `AdminReviewsManagement-spaceTop3-y2lwS`,
	"spaceTop4": `AdminReviewsManagement-spaceTop4-qcsg1`,
	"spaceTop5": `AdminReviewsManagement-spaceTop5-PXot4`,
	"spaceTop6": `AdminReviewsManagement-spaceTop6-Vi1xj`,
	"spaceTop7": `AdminReviewsManagement-spaceTop7-LSsWJ`,
	"spaceTop8": `AdminReviewsManagement-spaceTop8-HuUDM`,
	"noMargin": `AdminReviewsManagement-noMargin-X_09I`,
	"padding1": `AdminReviewsManagement-padding1-NorlO`,
	"padding2": `AdminReviewsManagement-padding2-ORdMJ`,
	"padding3": `AdminReviewsManagement-padding3-UNlNj`,
	"padding4": `AdminReviewsManagement-padding4-Xj17H`,
	"padding5": `AdminReviewsManagement-padding5-di7vk`,
	"padding6": `AdminReviewsManagement-padding6-MyBkh`,
	"padding7": `AdminReviewsManagement-padding7-DEA_R`,
	"paddingTop1": `AdminReviewsManagement-paddingTop1-ZFjOg`,
	"paddingTop2": `AdminReviewsManagement-paddingTop2-TLmNR`,
	"paddingTop3": `AdminReviewsManagement-paddingTop3-ifIW7`,
	"paddingTop4": `AdminReviewsManagement-paddingTop4-Rt0gH`,
	"paddingTop5": `AdminReviewsManagement-paddingTop5-BFzPe`,
	"paddingTop6": `AdminReviewsManagement-paddingTop6-orvG0`,
	"paddingTop7": `AdminReviewsManagement-paddingTop7-m9XJT`,
	"noPadding": `AdminReviewsManagement-noPadding-xHJHQ`,
	"spaceMarginBottom0": `AdminReviewsManagement-spaceMarginBottom0-yHcOp`,
	"textBold": `AdminReviewsManagement-textBold-UTEZT`,
	"textBolder": `AdminReviewsManagement-textBolder-qRkx0`,
	"textNormal": `AdminReviewsManagement-textNormal-P9C1d`,
	"textDarkBlue": `AdminReviewsManagement-textDarkBlue-BB6d2`,
	"textLightBlue": `AdminReviewsManagement-textLightBlue-gVNRe`,
	"textLightSandleGreen": `AdminReviewsManagement-textLightSandleGreen-QKWAM`,
	"textLightBrown": `AdminReviewsManagement-textLightBrown-k8jjV`,
	"textMediumMaroon": `AdminReviewsManagement-textMediumMaroon-rUMW0`,
	"textBrown": `AdminReviewsManagement-textBrown-zXUBF`,
	"textMaroon": `AdminReviewsManagement-textMaroon-MJJjC`,
	"textDarkBrown": `AdminReviewsManagement-textDarkBrown-_MxLe`,
	"textMediumBrown": `AdminReviewsManagement-textMediumBrown-kY21R`,
	"textSkyBlue": `AdminReviewsManagement-textSkyBlue-e1OVR`,
	"textGray": `AdminReviewsManagement-textGray-_v0Cc`,
	"errorMessage": `AdminReviewsManagement-errorMessage-sCLqH`,
	"userText": `AdminReviewsManagement-userText-yQTOM`,
	"panelHeader": `AdminReviewsManagement-panelHeader-ddJN0`,
	"exportSection": `AdminReviewsManagement-exportSection-MLS1S`,
	"exportSectionGridSub": `AdminReviewsManagement-exportSectionGridSub-oOKWf`,
	"exportText": `AdminReviewsManagement-exportText-o_TC7`,
	"exportLinkImg": `AdminReviewsManagement-exportLinkImg-laZNn`,
	"exportImg": `AdminReviewsManagement-exportImg-suzog`,
	"linkBtn": `AdminReviewsManagement-linkBtn-KlQCa`,
	"table": `AdminReviewsManagement-table-DQqPa`,
	"tableRow": `AdminReviewsManagement-tableRow-lyVhT`,
	"tableCell": `AdminReviewsManagement-tableCell-qEQn2`,
	"formGroup": `AdminReviewsManagement-formGroup-HTFkm`,
	"marginTop0": `AdminReviewsManagement-marginTop0-JJp5f`,
	"marginBottom20": `AdminReviewsManagement-marginBottom20-BGybb`,
	"bannerImageBg": `AdminReviewsManagement-bannerImageBg-MLNoM`,
	"bannerDelete": `AdminReviewsManagement-bannerDelete-zoJrr`,
	"exportLink": `AdminReviewsManagement-exportLink-LNj__`,
	"seachContent": `AdminReviewsManagement-seachContent-MIcED`,
	"marginBottom9": `AdminReviewsManagement-marginBottom9-odZSA`,
	"spaceTop52": `AdminReviewsManagement-spaceTop52-rS8E5`,
	"profileViewInner": `AdminReviewsManagement-profileViewInner-cIh7V`,
	"profileViewMain": `AdminReviewsManagement-profileViewMain-OSMaT`,
	"profileViewlabel": `AdminReviewsManagement-profileViewlabel-JZldS`,
	"profileViewMainContent": `AdminReviewsManagement-profileViewMainContent-oIVgm`,
	"reviewsFormStar": `AdminReviewsManagement-reviewsFormStar-_LBKD`,
	"addLanguageText": `AdminReviewsManagement-addLanguageText-KUgqg`,
	"textRight": `AdminReviewsManagement-textRight-Z7ViW`
};
module.exports = ___CSS_LOADER_EXPORT___;
